import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProofSection } from '../components/ProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SystemSection } from '../components/SystemSection';
import { ModulesSection } from '../components/ModulesSection';
import { BonusSection } from '../components/BonusSection';
import { UrgencySection } from '../components/UrgencySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-hidden bg-white" data-id="element-256">
      <HeroSection data-id="element-257" />
      <ProofSection data-id="element-258" />
      <ProblemSection data-id="element-259" />
      <SystemSection data-id="element-260" />
      <ModulesSection data-id="element-261" />
      <BonusSection data-id="element-262" />
      <UrgencySection data-id="element-263" />
      <PricingSection data-id="element-264" />
      <TestimonialsSection data-id="element-265" />
      <GuaranteeSection data-id="element-266" />
      <FAQSection data-id="element-267" />
      <FinalCTA data-id="element-268" />
      <Footer data-id="element-269" />
      <PurchasePopup data-id="element-270" />
    </main>;
}